import React from 'react';
import { Link } from 'react-router-dom';

export type LandingBreadcrumbItem = {
  label: string;
  to?: string;
};

export type LandingBreadcrumbProps = {
  items: LandingBreadcrumbItem[];
};

const LandingBreadcrumb: React.FC<LandingBreadcrumbProps> = ({ items }) => (
  <nav className="mb-8 text-center text-xs text-slate-500 sm:text-left">
    {items.map((item, i) => (
      <React.Fragment key={`${item.label}-${i}`}>
        {i > 0 && (
          <span className="mx-2" aria-hidden>
            /
          </span>
        )}
        {item.to ? (
          <Link to={item.to} className="hover:text-purple-400">
            {item.label}
          </Link>
        ) : (
          <span className="text-slate-400">{item.label}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default LandingBreadcrumb;
